import { gql } from '@apollo/client';

export const GET_RACE_ANALYSIS = gql`
  query GetRaceAnalysis(
    $date: Date!, 
    $trackName: String!, 
    $isLatest: Boolean = true, 
    $analysisTypeId: Float = 1
  ) {
    raceAnalysis(
      date: $date, 
      trackName: $trackName, 
      isLatest: $isLatest, 
      analysisTypeId: $analysisTypeId
    ) {
      track {
        name
        state
        type
      }
      trackConditions {
        weather
        trackCondition
        penetrometer
        rail
        comment
        lastUpdate
      }
      races {
        race_id
        race_number
        race_name
        distance
        class
        age_restrictions
        weight_type
        prize_money
        selections {
          top {
            number
            horse_name
            jockey
            trainer
            weight
            barrier
            odds
            assessedOdds
            confidence
            analysis {
              summary
              pros
              cons
            }
          }
          value {
            number
            horse_name
            jockey
            trainer
            weight
            barrier
            odds
            assessedOdds
            confidence
            analysis {
              summary
              pros
              cons
            }
          }
          speed_map
          suggested_bets {
            type
            selection
            stake
          }
        }
      }
      bestBets {
        best {
          race
          number
          name
          confidence
          odds
          analysis
          stake
        }
        value {
          race
          number
          name
          confidence
          odds
          analysis
          stake
        }
      }
      quaddie {
        legs {
          race
          selections
        }
        cost
        comment
      }
    }
  }
`;

export const GET_TRACK_CONDITIONS = gql`
  query GetTrackConditions($date: Date!, $trackName: String!) {
    trackConditions(date: $date, trackName: $trackName) {
      weather
      trackCondition
      penetrometer
      rail
      comment
      lastUpdate
    }
  }
`;
